<template>
  <div class="row">
    <div class="col-xl-12">
      <container-headline class="col-xl-12" :headline="$t('global.blockingdate')" :col="3">
        <div class="row">
          <div class="ml-4 mr-2"></div>
          <div class="mr-2"></div>
        </div>
      </container-headline>
      <div class="row col-xl-12">
        <div class="col-xl-12 block belegliste br-t-l-0">
          <div>
            <b-table
              ref="selectableTable"
              tbody-tr-class="item"
              :items="sperrterminliste"
              :fields="fields"
              :busy="isBusy"
              show-empty
              sort-icon-left
              fixed
              selectable
              select-mode="range"
              @row-dblclicked="details"
            >
              <template v-slot:head(selected)="row">
                <b-form-checkbox
                  v-model="row.selected"
                  @input="selectAllRows(row)"
                ></b-form-checkbox>
              </template>

              <template v-slot:cell(selected)="row">
                <b-form-checkbox
                  v-model="row.item.selected"
                  @input="onRowSelected(row)"
                ></b-form-checkbox>
              </template>

              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

              <template #empty>
                <div v-if="ladeFehler" class="text-center text-danger my-2">
                  <strong>{{ $t("global.errorwhileloading") }}</strong>
                </div>
                <div v-if="!ladeFehler" class="text-center text-primary my-2">
                  <strong>{{ $t("global.nodataavailable") }}</strong>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/Api";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import { BSpinner } from "bootstrap-vue";
import ContainerHeadline from "@/components/ContainerHeadline";
import reiter from "@/mixins/Reiter";

export default {
  components: {
    ContainerHeadline,
    BSpinner,
  },
  mixins: [reiter],
  props: {
    raum: {
      type: String,
      required: false,
    },
    shown: {
      type: Boolean,
      required: false,
    },
  },
  watch: {
    shown(val) {
      if (val && this.sperrterminliste.length == 0) this.getTermine();
    },
  },
  data() {
    return {
      page: 0,
      infiniteId: +new Date(),
      anzahlProPage: 1000,
      isBusy: false,
      ladeFehler: false,
      sperrterminliste: [],
      fields: [
        { key: "selected", label: "" },
        { key: "von", sortable: true, label: this.$t("global.from") },
        { key: "von_uhrzeit", sortable: true, label: this.$t("global.TIme") },
        { key: "bis", sortable: true, label: this.$t("global.till") },
        { key: "bis_uhrzeit", sortable: true, label: this.$t("global.TIme") },
        { key: "bezeichnung", sortable: true, label: this.$t("global.designation")  },
      ],
      selected: [],
      selectedIds: [],
    };
  },
  computed: {
    queryParams: function () {
      var params = {
        page: this.page,
        count: this.anzahlProPage,
      };

      if (this.suche) params.suche = this.suche;

      return params;
    },
  },
  mounted() {
    if (this.shown && this.sperrterminliste.length == 0) this.getTermine();
    this.setHeaders("global", [
      "",
      "from",
      "TIme",
      "till",
      "TIme",
      "designation",
    ]);
  },
  created() {},
  methods: {
    getTermine() {
      this.isBusy = true;

      Api.get("sperrtermin/", {
        params: {
          raum: this.raum,
          page: this.page,
          count: this.anzahlProPage,
        },
      })
        .then((response) => {
          this.sperrterminliste = response.data;
          this.ladeFehler = false;
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.ladeFehler = true;
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    details(termin) {
      this.$router.push({
        path: "/ressourcen/sperrtermin/" + termin.id,
      });
    },
    infiniteHandler($state) {
      console.log("init");
      Api.get("sperrtermin/", {
        params: this.queryParams,
      }).then((response) => {
        console.log("final");
        if (response.data.length === this.anzahlProPage) {
          this.page += 1;
          this.termin.push(...response.data);
          $state.loaded();
        } else {
          this.termin.push(...response.data);
          $state.complete();
        }
      });
    },
    selectAllRows(row) {
      if (row.selected) {
        this.$refs.selectableTable.items.forEach((gp) => {
          gp.selected = true;
          if (!this.selectedIds.includes(gp.id)) {
            this.selectedIds.push(gp.id);
          }
        });
      } else {
        this.$refs.selectableTable.items.forEach((gp) => {
          gp.selected = false;
        });
        this.selectedIds = [];
      }
      this.$forceUpdate();
    },
    onRowSelected(row) {
      if (row.item.selected) {
        this.selectedIds.push(row.item.id);
      } else {
        this.selectedIds = this.selectedIds.filter((id) => id != row.item.id);
      }
    },
  },
};
</script>